<template>
  <div class="fadein">
    <div class="h30"></div>
    <div class="goback" @click="goback"></div>
    <transition name="el-zoom-in-center">
      <div
        class="center1200 bg-white shadow"
        v-if="actor.name"
        style="position: relative;"
      >
        <div class="h20"></div>
        <div class="center-title">
          <img class="title-pic" src="/static/img/title-left.png" alt="" />
          演员详情
          <img class="title-pic" src="/static/img/title-right.png" alt="" />
        </div>
        <div class="padding20">
          <el-breadcrumb
            separator="/"
            style="position: absolute;left:20px;top:27px;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/movies' }"
              >电影</el-breadcrumb-item
            >
            <el-breadcrumb-item
              ><a href="javascript:;" @click="goback()"
                >电影详情</a
              ></el-breadcrumb-item
            >
            <el-breadcrumb-item>演员详情</el-breadcrumb-item>
          </el-breadcrumb>
          <div style="display: flex;justify-content: space-between;">
            <div class="actorpic-big" style="width:300px">
              <img :src="actor.actor_pic" alt="" class="moviepic-big" />
            </div>
            <div style="width:800px;" class="actorinfo">
              <h2>{{ actor.name }}</h2>
              <p>出生地：{{ actor.birthplace }}</p>
              <p>出生日期：{{ actor.birthdate }}</p>
              <p>爱称/别名：{{ actor.aka }}</p>
              <p>职业：{{ actor.jobs }}</p>
              <!-- <p>关注：{{ actor.focus_count }}</p> -->
              <!-- <div > -->
              个人简介：
              <span class="summary">{{ actor.summary }}</span>
              <!-- </div> -->
            </div>
            <!-- <div style="clear: both;"></div> -->
          </div>
          <div class="h20"></div>
        </div>
      </div>
    </transition>
    <div class="h30"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      actor: {},
      keyword: "",
      page: 1,
      aid: 0
    };
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.name == "actor") {
        (this.actor = {}), (this.aid = this.$route.params.aid);
        this.getActor();
      }
    }
  },
  mounted() {
    (this.actor = {}), (this.aid = this.$route.params.aid);
    this.getActor();
  },
  methods: {
    getActor() {
      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/actors/" + this.aid,
        type: "get",
        success: ret => {
          this.actor = ret;
        }
      });
    },

    //返回
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.actorinfo {
  height: 100%;
}
.actorinfo p {
  height: 30px;
  line-height: 30px;
}
.summary {
  width: 100px;
  height: auto;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/actor.vue